import { type DataWarehouseRefFragment } from '@spotify/confidence-graphql';

export const findPrimaryWarehouse = <
  T extends Pick<DataWarehouseRefFragment, 'name' | 'isPrimary'>,
>(
  warehouses: T[] | undefined,
): T | undefined => {
  if (!warehouses?.length) return undefined;
  return warehouses.find(warehouse => warehouse.isPrimary) ?? warehouses[0];
};
